module.exports = __webpack_public_path__ + "static/media/1st.4af49831.svg";